export class RedisError {
  message = 'redisError';
}
